import { render, staticRenderFns } from "./settlementEdit.vue?vue&type=template&id=6f206599&"
import script from "./settlementEdit.vue?vue&type=script&lang=js&"
export * from "./settlementEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports